import { BusinessIndicator } from '@/entities/businessIndicator';
import { Seller, SellerNoId, SellerWDate } from '@/entities/seller';
import { sellerService } from '@/services/SellerService';
import { useEffect, useState } from 'react';

export const useSellers = () => {
  const [seller, setSellers] = useState<Seller[]>([]);
  const [ searchedSellers, setSearchedSellers ] = useState<SellerWDate[]>([]);
  const [errorDeleteSeller, setErrorDeleteSeller] = useState(false);
  const [errorSearchSeller, setErrorSearchSeller] = useState(false);
  useEffect(()=>{
    const fetchSellers = async () => {
      try{
        const response = await sellerService.getAllSeller();
        if(response){
          const vendedores = response.map((i:any)=>({
            id:i.id,
            name:i.name,
            commission:i.commission,
            phone:i.phone,
            email:i.email
          }));
          setSellers(vendedores);
          setErrorDeleteSeller(false);
          
        }

      }catch(e){
        console.error(`Error ao carregar dados ${e}`);
      }
                
    };

    fetchSellers();
  },[]);

  const createSeller = async (Seller:SellerNoId) => {
    try{
      const response = await sellerService.createSeller(Seller);
      if(response){
        return {
          id: response.id,
          name: response.name,
          phone: response.phone,
          email: response.email,
          commission: response.commission
        };
      }
    }catch(e){
      console.error('Algo de errado não está certo, meu chapa ',e);
    }
  };

  const updateSeller = async (id:number, Seller:Seller) => {
    try{
      const response = await sellerService.updateSeller(id, Seller);
      if(response){
        return response;
      }
    }catch(e){
      console.error('Algo de errado não está certo, meu chapa ',e);
    }
  };

  const deleteSeller = async (id: number) => {
    try {
      const response = await sellerService.deleteSeller(id);
      if (response) { 
        return response; 
      }
      setErrorDeleteSeller(false);
    } catch (e) {
      console.error('Algo de errado não está certo, meu chapa ', e);
      setErrorDeleteSeller(true); // Define como true em caso de erro
    }
  };

  const searchSeller = async (contains:string) => {
    try{
      const response = await sellerService.searchSeller(contains);
      if(response){
        const SellersSearched = response.map((i:any)=>({
          id: i.id,
          name:i.name,
          phone: i.phone,
          email: i.email,
          commission: i.commission,
          createdAt: i.createdAt
        }));
        setSearchedSellers(SellersSearched);
      }
    }catch(e){
      console.error('Deu ruim, meu chapa: ', e);
    }
  };

  return{
    seller,
    errorDeleteSeller,
    createSeller,
    updateSeller,
    deleteSeller,
    searchSeller,
    searchedSellers
  };
};
